module.exports = (context) => {
  const siteMode = context && typeof context.shoppingMode === 'string' ? context.shoppingMode : 'SITE';
  const regionCode = context && typeof context.regionCode === 'string' ? context.regionCode : 'US';
  let mode = 'us';
  let domestic;

  if (context && typeof context.domestic === 'boolean') {
    ({ domestic } = context);
  } else if (regionCode.toLowerCase() === 'us') {
    domestic = true;
  } else {
    domestic = false;
  }
  if (siteMode.toLowerCase() === 'wedding_registry') {
    mode = 'reg';
  } else if (!domestic) {
    mode = 'intl';
  }
  return mode;
};



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/Polaris/header-footer-wgl/polaris_deploy_header-footer-wgl_deployable_pipeline/package/node_modules/@feature/footer/src/helpers/getMcomFooterSiteMode.js